import request from '@/api/axios';

// 计算运费
const getFreight = (params: object) => {
    return request({
        url: '/order/trade/freight/charge',
        method: 'get',
        data: params,
    });
};

// 获取地址
const getAddress = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/receive/address/userId',
        method: 'get',
        data: params,
    });
};

// 新增/更新地址
const setAddress = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/receive/address/save',
        method: 'post',
        data: params,
    });
};

// 删除地址
const deleteAddress = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/receive/address/remove',
        method: 'delete',
        data: params,
    });
};

// 根据订单信息生成订单
const submitOrder = (params: object) => {
    return request({
        url: '/order/trade/submit',
        method: 'post',
        data: params,
    });
};

// 获取订单结算页数据（现货订单）
const orderTrade = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/spot/data',
        method: 'post',
        data: params,
    });
};

// 获取订单结算页数据（期货订单）
const orderFuturesTrade = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/futures/data',
        method: 'post',
        data: params,
    });
};

// 获取发票列表
const getBill = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/bill/info/list',
        method: 'get',
        data: params,
    });
};

// 新增发票信息
const addBill = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/bill/info/save',
        method: 'post',
        data: params,
    });
};
// 编辑发票信息
const updateBill = (params: object) => {
    return request({
        url: '/order/bill/info/update',
        method: 'put',
        data: params,
    });
};

// 编辑发票信息
const updateInvoiceTitle = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/bill/info/update',
        method: 'post', // 这个的请求方式与updateBill的不一样
        data: params,
    });
};

// 获取发票抬头列表
const getInvoiceTitleList = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/bill/info/pageList',
        method: 'post',
        data: params,
    });
};

// 获取发票抬头的详情数据
const getInvoiceTitleDetail = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/bill/info/detail',
        method: 'get',
        data: params,
    });
};

// 删除发票抬头
const deleteInvoiceTitle = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/bill/info/delete',
        method: 'delete',
        data: params,
    });
};

// 搜索企业名称和纳税号列表
const billCompanySearch = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/bill/info/billCompanySearch',
        method: 'post',
        data: params,
    });
};

// 我的发票列表
const getInvoiceList = (params: object) => {
    return request({
        url: '/order/bill/pageList',
        method: 'post',
        data: params,
    });
};

// 开票详情
const getInvoiceDetail = (params: object) => {
    return request({
        url: '/order/bill/orderBillDetailList',
        method: 'get',
        data: params,
    });
};

// 订单管理
const getOrderList = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/page',
        method: 'get',
        data: params,
    });
};

// 获取订单详情
const getOrderDetails = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/detail',
        method: 'get',
        data: params,
    });
};

// 获取订单详情
const getOrderDetail = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/status/payEventStatus',
        method: 'get',
        data: params,
    });
};

// 投诉申请
const complainSave = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/complain/save',
        method: 'post',
        data: params,
    });
};
// 投诉分页
const getcomplain = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/complain/page',
        method: 'get',
        data: params,
    });
};
// 撤回投诉
const backComplain = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/complain/revoke',
        method: 'get',
        data: params,
    });
};

// 投诉详情
const complainDetails = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/complain/detail',
        method: 'get',
        data: params,
    });
};

// 获取退货退款列表
const getBackGoods = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/page',
        method: 'get',
        data: params,
    });
};

// 退货退款
const refundPost = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/refund',
        method: 'post',
        data: params,
    });
};

// 计算申请退款前的退款金额（退货退款用）
const calculateRefundAmountBeforeApply = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/refund/calculateRefundAmountBeforeApply',
        method: 'post',
        data: params,
    });
};

// 样品订单计算申请退款前的退款金额（退货退款用）
const sampleCalculateRefundAmountBeforeApply = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/sample/refund/calculateRefundAmountBeforeApply',
        method: 'post',
        data: params,
    });
};

// 退货详情
const afterSalesDetails = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/detail',
        method: 'get',
        data: params,
    });
};

// 撤销退货退款申请
const revokeBack = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/revoke',
        method: 'get',
        data: params,
    });
};

// 完成交易
const closeDeal = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/close/deal',
        method: 'get',
        data: params,
    });
};

// 可用优惠
const couponUserList = (params: object) => {
    return request({
        url: '/coupon/user/list',
        method: 'get',
        data: params,
    });
};
// 可用优惠基础
const couponDetails = (params: object) => {
    return request({
        url: '/coupon/user/detail',
        method: 'get',
        data: params,
    });
};
//退款校验
const Refundverify = (params: object) => {
    return request({
        url: '/order/verify',
        method: 'get',
        data: params,
    });
};
//退货商品寄回
const goodreturn = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/orderRefund/return',
        method: 'post',
        data: params,
    });
};

// 校验订单状态
const OrderStatus = (id: string) => {
    return request({
        url: '/service/center/pc/order/status',
        method: 'get',
        data: {
            orderId: id,
            isApi2: true
        },
    });
};
// 校验投诉状态
const complainStatus = (id) =>{
    
    return request({
        url: '/service/center/complain/verify',
        method: 'get',
        data: {
            id: id,
            isApi2: true
        },
    });
}

const cancelOrder = (id) =>{
    return request({
        url: '/service/center/pc/cancel',
        method: 'get',
        data: {
            orderId: id,
            isApi2: true
        },
    });
}

const getUsableUserCouponList = (orderSn) =>{
    return request({
        url: '/service/center/pc/getUsableUserCouponList',
        method: 'get',
        data: {
            orderSn,
            isApi2: true,
        },
    });
}

const changeUseOrderUserCoupon = (params) =>{
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/changeUseOrderUserCoupon',
        method: 'post',
        data: params
    });
}

// 申请询价询交期
const consultAdd =  (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/order/procureConsult/apply',
        url:'/service/center/procureConsult/apply', // 二期接口
        method: 'post',
        data: params,
    });
};
const checkBeforeApply =  (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/order/procureConsult/checkBeforeApply',
        url: '/service/center/procureConsult/checkBeforeApply', // 二期接口
        method: 'post',
        data: params,
    });
};

// 产品定制申请
const customizationAdd =  (params: object) => {
    return request({
        url: '/order/orderCustomization/add',
        method: 'post',
        data: params,
    });
};

// 物流获取历史
const getLogistics =  (params: object) => {
    return request({
        url: '/stock/order/logistics/log/getLogByOrderSn',
        method: 'get',
        data: params,
    });
};

// 物流获取历史，根据物流单号
const getLogByLogisticsSn = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/order/logistics/log/getLogByLogisticsSn',
        method: 'get',
        data: params,
    });
};

// 查询客户寄回商品的目的仓库地址
const warehouseAddress =  () => {
    return request({
        url: '/service/center/orderRefund/userReturn/warehouseAddress',
        method: 'get',
        data: {
            isApi2: true
        }
    });
};

// 物流下单
const cOrder =  (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/order/logistics/cOrder',
        method: 'post',
        data: params,
    });
};

// 取消物流下单
const cOrderCancel =  (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/order/logistics/cOrderCancel',
        method: 'post',
        data: params,
    });
};

// 物流分页
const cOrderPage =  (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/order/logistics/page',
        method: 'post',
        data: params,
    });
};



// 获取当前用户的样品申请单申请页数据信息
const canSampleApplyOrderTrade = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/sampleOrder/trade/data',
        method: 'get',
        data: params,
    });
};

// 获取样品活动结算页数据
const sampleActivityOrderData = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/sample/data',
        method: 'post',
        data: params,
    });
};


// 提交样品申请单
const submitCanSampleApplyOrder = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/sampleOrder/trade/submit',
        method: 'post',
        data: params,
    });
};

// 获取样品申请单供应商的仓库下拉框数据
const sampleOrderSpot = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/sampleOrder/spot/sampleOrderData',
        method: 'post',
        data: params
    });
};

// 样品清单审核通过-回填地址和发票后样品申请订单
const submitSampleOrder = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/sampleOrder/update/address',
        method: 'put',
        data: params
    });
};
  
// 样品活动审核通过-回填地址和发票后样品申请订单
const submitSampleActivityOrder = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/trade/sample/submit',
        method: 'post',
        data: params
    });
};

// 样品申请列表
const getCanSampleApplyList = (params: object) => {
    return request({
        url: '/order/sampleOrder/pageList',
        method: 'post',
        data: params,
    });
};

// 取消样品申请
const cancelCanSampleOrder = (id) =>{
    return request({
        url: '/order/sampleOrder/cancel',
        method: 'get',
        data: {
            sampleOrderId: id
        },
    });
}
// 获取样品详情
const sampleDetail = (id) =>{
    return request({
        url: '/order/sampleOrder/detail',
        method: 'get',
        data: {
            sampleOrderSn: id
        },
    });
}

// 确认收货
const sampleCloseDeal = (params: object) => {
    return request({
        url: '/order/sampleOrder/close/deal',
        method: 'get',
        data: params,
    });
};

// 获取「现货订单」结算中的仓库物流运费信息数据
const shippingData = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/spot/shippingData',
        method: 'post',
        data: params,
    });
};

// 获取「期货订单」结算中的仓库物流运费信息数据
const futuresShippingData = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/futures/shippingData',
        method: 'post',
        data: params,
    });
};

// 提交生成「现货订单」
const spotSubmit = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/spot/submit',
        method: 'post',
        data: params,
    });
};

// 提交生成「期货订单」
const futuresSubmit = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/trade/futures/submit',
        method: 'post',
        data: params,
    });
};

// 获取拆分订单详情
const getOrderSplitDetail = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/service/center/pc/orderSplitDetail',
        method: 'get',
        data: params,
    });
};

const orderApi = {
    getFreight,
    getAddress,
    setAddress,
    deleteAddress,
    orderTrade,
    orderFuturesTrade,
    getBill,
    addBill,
    updateBill,
    submitOrder,
    getOrderList,
    getOrderDetails,
    getOrderDetail,
    complainSave,
    getcomplain,
    complainDetails,
    backComplain,
    refundPost,
    getBackGoods,
    afterSalesDetails,
    revokeBack,
    closeDeal,
    couponUserList,
    couponDetails,
    Refundverify,
    goodreturn,
    OrderStatus,
    complainStatus,
    cancelOrder,
    consultAdd,
    checkBeforeApply,
    customizationAdd,
    getLogistics,
    getInvoiceTitleList,
    getInvoiceTitleDetail,
    updateInvoiceTitle,
    deleteInvoiceTitle,
    billCompanySearch,
    getInvoiceList,
    getInvoiceDetail,
    warehouseAddress,
    cOrder,
    cOrderCancel,
    cOrderPage,
    getLogByLogisticsSn,
    canSampleApplyOrderTrade,
    submitCanSampleApplyOrder,
    getCanSampleApplyList,
    cancelCanSampleOrder,
    sampleDetail,
    sampleCloseDeal,
    getUsableUserCouponList,
    changeUseOrderUserCoupon,
    calculateRefundAmountBeforeApply,
    shippingData,
    futuresShippingData,
    spotSubmit,
    futuresSubmit,
    getOrderSplitDetail,
    sampleOrderSpot,
    submitSampleOrder,
    submitSampleActivityOrder,
    sampleCalculateRefundAmountBeforeApply,
    sampleActivityOrderData
};

export default orderApi;
